<a
  class="header-item"
  [attr.title]="'header.register' | transloco"
  (click)="onSignUpButtonClick()">
  {{ 'header.register' | transloco }}
</a>
<a
  class="header-item"
  [attr.title]="'header.login' | transloco"
  (click)="onLoginButtonClick()">
  {{ 'header.login' | transloco }}
</a>

<div
  class="nested-item nested-item-language"
  (click)="openLanguages()">
  <div *ngIf="languageService.current$ | async as language">
    <sh-main-nav-language-flag [code]="language"></sh-main-nav-language-flag>
  </div>
  <ui-icon
    class="chevron"
    key="chevron-right">
  </ui-icon>
</div>
<div
  class="nested-item-content"
  *ngIf="(languagesOpen$ | async) === true">
  <sh-main-nav-languages-mobile
    (closeLanguageBar)="closeLanguages()"
    (closeMenu)="onCloseMenu()">
  </sh-main-nav-languages-mobile>
</div>
